import { useEffect } from 'react';

/**
 * Locks background scroll when a modal is open.
 * Targets the main content area (and body) to prevent scroll-through.
 */
export function useLockScroll(isActive: boolean) {
  useEffect(() => {
    if (!isActive) return;

    const main = document.querySelector('main');
    const prevMainOverflow = main?.style.overflow ?? '';
    const prevBodyOverflow = document.body.style.overflow;

    if (main) {
      main.style.overflow = 'hidden';
    }
    document.body.style.overflow = 'hidden';

    return () => {
      if (main) {
        main.style.overflow = prevMainOverflow;
      }
      document.body.style.overflow = prevBodyOverflow;
    };
  }, [isActive]);
}
